module.exports = __webpack_public_path__ + "static/media/sidebar-case.6b907830.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-case.svg
// module id = 795
// module chunks = 0